// ============================================================================
// Utility Functions - Shared between Frontend and Backend
// ============================================================================

/**
 * Predefined color palette for stock icons
 * These colors are visually distinct and work well on white backgrounds
 */
const STOCK_COLORS = [
  '#8B5CF6', // Purple
  '#10B981', // Emerald
  '#F59E0B', // Amber
  '#EF4444', // Red
  '#3B82F6', // Blue
  '#EC4899', // Pink
  '#14B8A6', // Teal
  '#F97316', // Orange
  '#6366F1', // Indigo
  '#84CC16', // Lime
  '#06B6D4', // Cyan
  '#A855F7', // Violet
];

/**
 * Generate a deterministic color based on ticker symbol
 * Same ticker will always produce the same color
 * 
 * @param ticker - Stock ticker symbol (e.g., "TCS", "INFY")
 * @returns Hex color string (e.g., "#8B5CF6")
 */
export function getTickerColor(ticker: string): string {
  // Simple hash function to convert ticker to a number
  let hash = 0;
  for (let i = 0; i < ticker.length; i++) {
    const char = ticker.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Use absolute value and modulo to get index
  const index = Math.abs(hash) % STOCK_COLORS.length;
  return STOCK_COLORS[index];
}

export { STOCK_COLORS };
